var map = {
	"./confirmation/confirmation.module": [
		"./src/app/confirmation/confirmation.module.ts",
		"common",
		"confirmation-confirmation-module"
	],
	"./covid-info/covid-info.module": [
		"./src/app/hotel/covid-info/covid-info.module.ts",
		"covid-info-covid-info-module"
	],
	"./hotel-home/accor-live/accor-live.module": [
		"./src/app/hotel/hotel-home/accor-live/accor-live.module.ts",
		"common",
		"hotel-home-accor-live-accor-live-module"
	],
	"./hotel-home/connect/connect.module": [
		"./src/app/hotel/hotel-home/connect/connect.module.ts",
		"default~connect-connect-module~hotel-home-connect-connect-module",
		"hotel-home-connect-connect-module"
	],
	"./hotel-home/conserve/conserve.module": [
		"./src/app/hotel/hotel-home/conserve/conserve.module.ts",
		"conserve-conserve-module"
	],
	"./hotel-home/explore-dining-venues/explore-dining-venues.module": [
		"./src/app/hotel/hotel-home/explore-dining-venues/explore-dining-venues.module.ts",
		"explore-dining-venues-explore-dining-venues-module"
	],
	"./hotel-home/hotel-home.module": [
		"./src/app/hotel/hotel-home/hotel-home.module.ts",
		"default~hotel-home-hotel-home-module~hotel-home-laundry-service-irs-laundry-irs-laundry-module~hotel~460df1a2",
		"hotel-home-hotel-home-module"
	],
	"./hotel-home/ird/ird.module": [
		"./src/app/hotel/hotel-home/ird/ird.module.ts",
		"default~hotel-home-ird-ird-module~hotel-home-ird-menu-category-menu-category-module~ird-ird-module",
		"common",
		"hotel-home-ird-ird-module"
	],
	"./hotel-home/ird/menu-category/menu-category.module": [
		"./src/app/hotel/hotel-home/ird/menu-category/menu-category.module.ts",
		"default~hotel-home-ird-ird-module~hotel-home-ird-menu-category-menu-category-module~ird-ird-module",
		"default~hotel-home-ird-menu-category-menu-category-module~hotel-hotel-module~menu-category-menu-cate~5f8bf585",
		"default~hotel-home-ird-menu-category-menu-category-module~menu-category-menu-category-module",
		"hotel-home-ird-menu-category-menu-category-module"
	],
	"./hotel-home/journey/journey-connectivity/journey-connectivity.module": [
		"./src/app/hotel/hotel-home/journey/journey-connectivity/journey-connectivity.module.ts",
		"journey-connectivity-journey-connectivity-module"
	],
	"./hotel-home/journey/journey-experience/journey-experience.module": [
		"./src/app/hotel/hotel-home/journey/journey-experience/journey-experience.module.ts",
		"journey-experience-journey-experience-module"
	],
	"./hotel-home/journey/journey-highlights/journey-highlights.module": [
		"./src/app/hotel/hotel-home/journey/journey-highlights/journey-highlights.module.ts",
		"common",
		"hotel-home-journey-journey-highlights-journey-highlights-module"
	],
	"./hotel-home/journey/journey-meetings/journey-meetings.module": [
		"./src/app/hotel/hotel-home/journey/journey-meetings/journey-meetings.module.ts",
		"journey-meetings-journey-meetings-module"
	],
	"./hotel-home/journey/journey-poi/journey-poi.module": [
		"./src/app/hotel/hotel-home/journey/journey-poi/journey-poi.module.ts",
		"journey-poi-journey-poi-module"
	],
	"./hotel-home/journey/journey-public-area/journey-public-area.module": [
		"./src/app/hotel/hotel-home/journey/journey-public-area/journey-public-area.module.ts",
		"journey-public-area-journey-public-area-module"
	],
	"./hotel-home/journey/journey-service/journey-service.module": [
		"./src/app/hotel/hotel-home/journey/journey-service/journey-service.module.ts",
		"journey-service-journey-service-module"
	],
	"./hotel-home/journey/journey-swimming-pool/journey-swimming-pool.module": [
		"./src/app/hotel/hotel-home/journey/journey-swimming-pool/journey-swimming-pool.module.ts",
		"journey-swimming-pool-journey-swimming-pool-module"
	],
	"./hotel-home/journey/journey-transportation/journey-transportation.module": [
		"./src/app/hotel/hotel-home/journey/journey-transportation/journey-transportation.module.ts",
		"journey-transportation-journey-transportation-module"
	],
	"./hotel-home/journey/journey-welcome/journey-welcome.module": [
		"./src/app/hotel/hotel-home/journey/journey-welcome/journey-welcome.module.ts",
		"journey-welcome-journey-welcome-module"
	],
	"./hotel-home/journey/journey-well-being/journey-well-being.module": [
		"./src/app/hotel/hotel-home/journey/journey-well-being/journey-well-being.module.ts",
		"journey-well-being-journey-well-being-module"
	],
	"./hotel-home/journey/journey.module": [
		"./src/app/hotel/hotel-home/journey/journey.module.ts",
		"common",
		"hotel-home-journey-journey-module"
	],
	"./hotel-home/laundry-service/active-breakfast/active-breakfast.module": [
		"./src/app/hotel/hotel-home/laundry-service/active-breakfast/active-breakfast.module.ts",
		"default~active-breakfast-active-breakfast-module~hotel-home-spa-spa-explore-spa-explore-module~hotel~a0666cee",
		"active-breakfast-active-breakfast-module"
	],
	"./hotel-home/laundry-service/irs-in-room-essentials/irs-in-room-essentials.module": [
		"./src/app/hotel/hotel-home/laundry-service/irs-in-room-essentials/irs-in-room-essentials.module.ts",
		"default~hotel-home-laundry-service-irs-in-room-essentials-irs-in-room-essentials-module~irs-in-room-~706d4f7e",
		"hotel-home-laundry-service-irs-in-room-essentials-irs-in-room-essentials-module"
	],
	"./hotel-home/laundry-service/irs-in-room-fitness/irs-in-room-fitness.module": [
		"./src/app/hotel/hotel-home/laundry-service/irs-in-room-fitness/irs-in-room-fitness.module.ts",
		"default~hotel-home-laundry-service-irs-in-room-fitness-irs-in-room-fitness-module~hotel-home-laundry~7353b30f",
		"default~hotel-home-laundry-service-irs-in-room-fitness-irs-in-room-fitness-module~irs-in-room-fitnes~690cbe69",
		"hotel-home-laundry-service-irs-in-room-fitness-irs-in-room-fitness-module"
	],
	"./hotel-home/laundry-service/irs-in-room-refreshment/irs-in-room-refreshment.module": [
		"./src/app/hotel/hotel-home/laundry-service/irs-in-room-refreshment/irs-in-room-refreshment.module.ts",
		"default~hotel-home-laundry-service-irs-in-room-fitness-irs-in-room-fitness-module~hotel-home-laundry~7353b30f",
		"default~hotel-home-laundry-service-irs-in-room-refreshment-irs-in-room-refreshment-module~hotel-hote~cf1e503b",
		"default~hotel-home-laundry-service-irs-in-room-refreshment-irs-in-room-refreshment-module~irs-in-roo~99929bc0",
		"hotel-home-laundry-service-irs-in-room-refreshment-irs-in-room-refreshment-module"
	],
	"./hotel-home/laundry-service/irs-laundry/irs-laundry.module": [
		"./src/app/hotel/hotel-home/laundry-service/irs-laundry/irs-laundry.module.ts",
		"default~hotel-home-hotel-home-module~hotel-home-laundry-service-irs-laundry-irs-laundry-module~hotel~460df1a2",
		"default~hotel-home-laundry-service-irs-laundry-irs-laundry-module~irs-laundry-irs-laundry-module~lau~3e196aad",
		"hotel-home-laundry-service-irs-laundry-irs-laundry-module"
	],
	"./hotel-home/laundry-service/irs-pillow/irs-pillow.module": [
		"./src/app/hotel/hotel-home/laundry-service/irs-pillow/irs-pillow.module.ts",
		"irs-pillow-irs-pillow-module"
	],
	"./hotel-home/laundry-service/irs-tv/irs-tv.module": [
		"./src/app/hotel/hotel-home/laundry-service/irs-tv/irs-tv.module.ts",
		"irs-tv-irs-tv-module"
	],
	"./hotel-home/laundry-service/laundry-service.module": [
		"./src/app/hotel/hotel-home/laundry-service/laundry-service.module.ts",
		"default~hotel-home-hotel-home-module~hotel-home-laundry-service-irs-laundry-irs-laundry-module~hotel~460df1a2",
		"hotel-home-laundry-service-laundry-service-module"
	],
	"./hotel-home/laundry-service/remote-instructions/remote-instructions.module": [
		"./src/app/hotel/hotel-home/laundry-service/remote-instructions/remote-instructions.module.ts",
		"remote-instructions-remote-instructions-module"
	],
	"./hotel-home/laundry-service/safe-instructions/safe-instructions.module": [
		"./src/app/hotel/hotel-home/laundry-service/safe-instructions/safe-instructions.module.ts",
		"safe-instructions-safe-instructions-module"
	],
	"./hotel-home/meet-play/meet-play.module": [
		"./src/app/hotel/hotel-home/meet-play/meet-play.module.ts",
		"meet-play-meet-play-module"
	],
	"./hotel-home/spa/spa-etiq/spa-etiq.module": [
		"./src/app/hotel/hotel-home/spa/spa-etiq/spa-etiq.module.ts",
		"default~hotel-home-spa-spa-etiq-spa-etiq-module~spa-etiq-spa-etiq-module",
		"hotel-home-spa-spa-etiq-spa-etiq-module"
	],
	"./hotel-home/spa/spa-explore/spa-explore.module": [
		"./src/app/hotel/hotel-home/spa/spa-explore/spa-explore.module.ts",
		"default~active-breakfast-active-breakfast-module~hotel-home-spa-spa-explore-spa-explore-module~hotel~a0666cee",
		"hotel-home-spa-spa-explore-spa-explore-module"
	],
	"./hotel-home/spa/spa-menu/spa-menu.module": [
		"./src/app/hotel/hotel-home/spa/spa-menu/spa-menu.module.ts",
		"default~hotel-home-laundry-service-irs-in-room-fitness-irs-in-room-fitness-module~hotel-home-laundry~7353b30f",
		"default~hotel-home-spa-spa-menu-spa-menu-module~hotel-home-spa-spa-module~spa-spa-module",
		"hotel-home-spa-spa-menu-spa-menu-module"
	],
	"./hotel-home/spa/spa.module": [
		"./src/app/hotel/hotel-home/spa/spa.module.ts",
		"default~hotel-home-laundry-service-irs-in-room-fitness-irs-in-room-fitness-module~hotel-home-laundry~7353b30f",
		"default~hotel-home-spa-spa-menu-spa-menu-module~hotel-home-spa-spa-module~spa-spa-module",
		"common",
		"hotel-home-spa-spa-module"
	],
	"./hotel-home/tv-guide/tv-guide.module": [
		"./src/app/hotel/hotel-home/tv-guide/tv-guide.module.ts",
		"tv-guide-tv-guide-module"
	],
	"./hotel/hotel.module": [
		"./src/app/hotel/hotel.module.ts",
		"default~hotel-home-laundry-service-irs-in-room-fitness-irs-in-room-fitness-module~hotel-home-laundry~7353b30f",
		"default~hotel-home-laundry-service-irs-in-room-refreshment-irs-in-room-refreshment-module~hotel-hote~cf1e503b",
		"default~active-breakfast-active-breakfast-module~hotel-home-spa-spa-explore-spa-explore-module~hotel~a0666cee",
		"default~hotel-home-ird-menu-category-menu-category-module~hotel-hotel-module~menu-category-menu-cate~5f8bf585",
		"hotel-hotel-module"
	],
	"./review-order/review-order.module": [
		"./src/app/review-order/review-order.module.ts",
		"default~hotel-home-laundry-service-irs-in-room-fitness-irs-in-room-fitness-module~hotel-home-laundry~7353b30f",
		"common",
		"review-order-review-order-module"
	],
	"./welcome/welcome.module": [
		"./src/app/welcome/welcome.module.ts",
		"common",
		"welcome-welcome-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;